import { Component, OnInit } from '@angular/core';
import { TranslatingDataService } from '../shared/services/translation/translating-data.service';
import { SharingDataService } from '../shared/services/sharingData/sharing-data.service';
import { map, catchError } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'creditCardApp';
  fullYear = new Date().getFullYear();
  LanguageClass = $localize`:@@LanguageClass:LanguageClass`;
  DirectionClass = $localize`:@@DirectionClass:DirectionClass`;

  constructor() //private translatingDataService: TranslatingDataService,
  //public sharingDataService: SharingDataService
  {}

  currentDate = new Date();

  ngOnInit() {
    // if (
    //   this.sharingDataService.minimumPaymtCalSharedData.TranslatedData == null
    // ) {
    //   this.sharingDataService.minimumPaymtCalSharedData.TranslatedData = this.translatingDataService.getTranlateddata();
    // }
  }
}
